import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const reminderService = {
  getReminders: () => axiosInstance.get(`/api/reminders`),
  createReminder: (data) => axiosInstance.post(`/api/reminders`, data),
  updateReminder: (id, data) => axiosInstance.put(`/api/reminders/${id}`, data),
  deleteReminder: (id) => axiosInstance.delete(`/api/reminders/${id}`)
};
